import { useBooleanFlagValue } from "@openfeature/react-sdk";
import flags from "../features/featureFlags/flags.js";
import { useSelector } from "react-redux";
import { selectIsMobileApp, selectIsMobileOrTabletApp } from "../store/reducers/runtimeDetails.js";
import { selectIsOnline } from "../features/networkStatus/networkStatusSlice";
import useScreenSize from "./useScreenSize.js";

const useAppModernisation = () => {
  const { isMobile } = useScreenSize();
  const isWebModernisationEnabled = true;
  const isCalculatorsLegacyIntegration = useBooleanFlagValue(
    flags.CALCULATORS_LEGACY_INTEGRATION,
    false,
  );
  const isMobileApp = useSelector(selectIsMobileApp);
  const isMobileOrTablet = useSelector(selectIsMobileOrTabletApp);
  const isOnline = useSelector(selectIsOnline);
  const isForceAppMode = useBooleanFlagValue(flags.FORCE_APP_MODE, false);
  const isEnhancedSearchEnabled = useBooleanFlagValue(flags.ENHANCED_SEARCH, false);
  // Offline fallback: if user is in installed mobile app context, retain app mode
  // even when feature flags are unavailable (eg offline landscape scenario).
  const isOfflineAppFallback = !isOnline && (isMobileApp || isMobileOrTablet);
  const isAppMode = isMobileApp || isMobileOrTablet || isForceAppMode || isOfflineAppFallback;
  const isEnhancedCounter = useBooleanFlagValue(flags.ENHANCED_COUNTER, false);

  // **Mobile view = either isAppMode i.e PWA (installed or forced or offlineApp) or responsive mobile layout (≤768px)
  const isMobileView = isAppMode || isMobile; // isMobile is determined by screen width ≤768px, which includes mobile/tablet devices in responsive mode. App mode is determined by hardware (mobile/tablet) or forced/offline app context, and does not change on resize.

  const isModernView = true; // isAppMode || isWebModernisationEnabled; // basically this will always true
  const isMoibileOrTabletApp = isMobileOrTablet || isForceAppMode || isOfflineAppFallback;

  return {
    isAppMode,
    isMoibileOrTabletApp,
    isWebModernisationEnabled,
    isCalculatorsLegacyIntegration,
    isEnhancedSearchEnabled,
    isEnhancedCounter,
    isMobileView,
    isModernView,
  };
};

export default useAppModernisation;
